import React from 'react';
import { Link } from 'react-router-dom';

// import PropTypes from 'prop-types';

// import './Header.css';

const Header = () => (
  <footer className="md-text-center">
    <a href="https://www.vias.be">Vias</a>
    {' — '}
    <Link className="secondary" to="/privacy-policy">
      Privacy Policy
    </Link>
    {' — '}
    <a href="mailto:brake@vias.be">Contact</a>
    {' — '}
    <Link className="secondary" to="/faq">
      FAQ
    </Link>
  </footer>
);

Header.propTypes = {

};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Footer.js